export default __webpack_public_path__ + "14181bc7929228858b47adbd3fcadf8b.svg";